// extracted by mini-css-extract-plugin
export default {"solidButton":"main-button-styles_component_solidButton__jFMgz","iconComponent":"main-button-styles_component_iconComponent__SJ21C"};